/*
 *
 * Workspace Projects reducer
 *
 */

import { fromJS } from 'immutable';
import * as constants from './constants';

const initialState = {
  projects: undefined,
  selectedProject: null,
  ingestionList: undefined,
  activityLiveList: null,
};

function workspaceProjectsReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case constants.SET_PROJECT_LIST:
      return state
        .set('projects', action.projects);
    case constants.SET_SELECTED_PROJECT:
      return state
        .set('selectedProject', action.project);
    case constants.GET_INGESTION_LIST:
      return state
        .set('ingestionList', action.ingestionList);
    case constants.GET_INGESTION_RECORD:
      return updateIngestionList(state, action.ingestionRecord);
    case constants.DELETE_INGESTION_RECORD:
      return deleteIngestionRecord(state, action.ingestionId);
    case constants.SET_ACTIVITY_LIVE_LIST:
      return setActivityLiveList(state, action.activityDetails);
    case constants.SET_ELEMENT_PUBLISHED_LIST:
      return setElementPublishedList(state, action.elementDetails);
    case constants.SET_MARKET_DERIVATIVE_LIST:
      return setMarketDerivativesList(state, action.elementDetails);
    case constants.SET_LANGUAGE_LIST:
      return setLanguagesList(state, action.elementDetails);
    default:
      return state;
  }
}

export const updateIngestionList = (state, newIngestionItem) => {
  const existingIngestionList = state.getIn(['ingestionList']) || [];
  const index = existingIngestionList.findIndex(
    (ingestionItem) => ingestionItem.id === newIngestionItem.id
  );
  const newIngestionList = [
    ...existingIngestionList.slice(0, index === -1 ? 0 : index),
    { ...existingIngestionList[index], ...newIngestionItem },
    ...existingIngestionList.slice(index + 1),
  ];
  return state.set('ingestionList', newIngestionList);
};

export const deleteIngestionRecord = (state, ingestionId) => {
  const existingIngestionList = state.getIn(['ingestionList']) || [];
  const newIngestionList = existingIngestionList.filter(
    (ingestionItem) => ingestionItem.id !== ingestionId
  );
  return state.set('ingestionList', newIngestionList);
};

export const setActivityLiveList = (state, activityDetails) => {
  const existingActivityLiveList = state.getIn(['activityLiveList']) || {};
  const updatedActivityLiveList = { ...existingActivityLiveList };
  updatedActivityLiveList[activityDetails.key] = activityDetails.liveStatus;
  return state.set('activityLiveList', updatedActivityLiveList);
};

export const setElementPublishedList = (state, elementDetails) => {
  const existingElementPublishedList = state.getIn(['elementPublishedList']) || {};
  const updatedElementPublishedList = { ...existingElementPublishedList };
  updatedElementPublishedList[elementDetails.key] = elementDetails.publishStatus;
  return state.set('elementPublishedList', updatedElementPublishedList);
};

export const setMarketDerivativesList = (state, elementDetails) => {
  const existingMarketDerivativesList = state.getIn(['marketDerivativesList']) || {};
  const updatedMarketDerivativesList = { ...existingMarketDerivativesList };
  updatedMarketDerivativesList[elementDetails.key] = elementDetails.conditionals;
  return state.set('marketDerivativesList', updatedMarketDerivativesList);
};

export const setLanguagesList = (state, elementDetails) => {
  const existingLanguagesList = state.getIn(['languagesList']) || {};
  const updatedLanguagesList = { ...existingLanguagesList };
  updatedLanguagesList[elementDetails.key] = elementDetails;
  return state.set('languagesList', updatedLanguagesList);
};

export {
  initialState,
};

export default workspaceProjectsReducer;
